import { Card, CardContent } from "@bcc/components/ui/card";
import { Users, UserPlus, TrendingUp, Award, LucideIcon } from "lucide-react";
import { setCustomersStatsTestId } from "./customers-stats.utils";

export interface StatData {
  name: string;
  value: string;
  icon: string;
  iconBg: string;
  iconColor: string;
}

interface CustomersStatsProps {
  data: StatData[];
  testId?: string;
}

const iconMap: Record<string, LucideIcon> = {
  Users,
  UserPlus,
  TrendingUp,
  Award,
};

interface StatCardProps {
  stat: StatData;
  index: number;
}

function StatCard({ stat, index }: StatCardProps) {
  const IconComponent = iconMap[stat.icon] || Users;

  return (
    <Card testId={setCustomersStatsTestId(`stat-card-${index}`)}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p
              className="text-sm font-medium text-muted-foreground"
              data-testid={setCustomersStatsTestId(`stat-label-${index}`)}
            >
              {stat.name}
            </p>
            <p
              className="mt-2 text-3xl font-bold tracking-tight"
              data-testid={setCustomersStatsTestId(`stat-value-${index}`)}
            >
              {stat.value}
            </p>
          </div>
          <div
            className={`flex h-12 w-12 items-center justify-center rounded-xl ${stat.iconBg}`}
          >
            <IconComponent className={`h-6 w-6 ${stat.iconColor}`} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function CustomersStats({ data, testId }: CustomersStatsProps) {
  return (
    <div
      data-testid={testId ?? setCustomersStatsTestId("container")}
      className="grid gap-4 md:grid-cols-2 lg:grid-cols-4"
    >
      {data.map((stat, index) => (
        <StatCard key={stat.name} stat={stat} index={index} />
      ))}
    </div>
  );
}
